import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { LiliButton } from '@lili/lili-frontend-common';
import { ReactComponent as PlusWhiteIcon } from '../../../../assets/svg/plus-white-icon.svg';
import { VIEWS_MAP } from '../../../../router/constants';
import { trackMixPanel } from '../../../../services/mixpanel.service';
import { featureAccess, LimitedFeatureType } from '../../../../services/appAccess.service';
import { FEATURE_FLAG } from '../../../../constants/general';
import { FeatureAccess } from '../../../AccountSettings/components/rolesAndPermissions/PermissionsList';

export const AddNewBillButton = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const billPayPermission = featureAccess(FEATURE_FLAG.BILL_PAY, LimitedFeatureType.BillPay);

  const handleButtonClick = () => {
    trackMixPanel('Act on Bill pay intro screen', { Action: 'Add a new bill' });
    navigate(`/${VIEWS_MAP.BILLS.BASE}/${VIEWS_MAP.BILLS.ADD_NEW_BILL}`);
  };
  return (
    <div>
      <LiliButton
        id='addNewBillBtn'
        data-test-id='BillsHub__add-new-bill-button'
        onClick={handleButtonClick}
        title={t('BILL_PAY.INTRO.ADD_BILL_BTN')}
        disabled={billPayPermission !== FeatureAccess.READ_WRITE}
        icon={<PlusWhiteIcon className='w-[20px] h-[20px]' />}
        className='h-[40px]'
      />
    </div>
  );
};
